import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { PATH } from '../../../constants/path';
import { STATIC_ROOT } from '../../../constants';
import { MODAL_TYPE_LOGIN } from '../../../services/modal/constants';

import { showModal } from '../../../services/modal/actions';

import SvgComponent from '../../SvgComponent';
import ButtonComponent from '../../button/ButtonComponent';
import LocalizedNavLink from '../../router/LocalizedNavLink';
import LinkButtonComponent from '../../button/LinkButtonComponent';

class LoggedOutComponent extends React.Component {
    showLoginModal = () =>
        this.props.showModal(MODAL_TYPE_LOGIN, { redirectUrl: this.props.urlConnection });

    render() {
        const { i18n, location, isButton } = this.props;

        const linkPathnames = [PATH.LOGIN_PATH, PATH.REGISTER_PATH];

        return (
            <div className="flex-container-h flex-center-alt">
                {isButton ? (
                    <React.Fragment>
                        {linkPathnames.includes(location.pathname) ? (
                            <LinkButtonComponent
                                to={PATH.LOGIN_PATH}
                                cssClass="connexion hidden-mobonly isButton"
                                color="main"
                                title={i18n.LOG_IN}
                                text={
                                    <React.Fragment>
                                        <SvgComponent src={`${STATIC_ROOT}/connexion.svg`} />
                                        <span>{i18n.LOG_IN}</span>
                                    </React.Fragment>
                                }
                            />
                        ) : (
                            <ButtonComponent
                                cssClass="connexion hidden-mobonly isButton"
                                color="main"
                                onClick={this.showLoginModal}
                                text={
                                    <React.Fragment>
                                        <SvgComponent src={`${STATIC_ROOT}/connexion.svg`} />
                                        <span>{i18n.LOG_IN}</span>
                                    </React.Fragment>
                                }
                            />
                        )}
                        <LinkButtonComponent
                            to={PATH.REGISTER_PATH}
                            cssClass="inscription hidden-mobonly isButton"
                            color="main"
                            title={i18n.REGISTER}
                            text={i18n.REGISTER}
                        />
                    </React.Fragment>
                ) : (
                    <React.Fragment>
                        {linkPathnames.includes(location.pathname) ? (
                            <LocalizedNavLink to={PATH.LOGIN_PATH}>{i18n.LOG_IN}</LocalizedNavLink>
                        ) : (
                            <div
                                className="connexion hidden-mobonly isLink"
                                onClick={this.showLoginModal}>
                                <span>{i18n.LOG_IN}</span>
                            </div>
                        )}
                        <div className="inscription hidden-mobonly isLink">
                            <LocalizedNavLink to={PATH.REGISTER_PATH}>
                                {i18n.REGISTER}
                            </LocalizedNavLink>
                        </div>
                    </React.Fragment>
                )}
            </div>
        );
    }
}

LoggedOutComponent.propTypes = {
    urlConnection: PropTypes.string.isRequired,
    i18n: PropTypes.object.isRequired,
    isButton: PropTypes.bool
};

const mapStateToProps = state => {
    return {
        i18n: state.i18n.feature.header.MEMBER_NAV,
        location: state.routing.location
    };
};

const mapDispatchToProps = { showModal };

export default connect(mapStateToProps, mapDispatchToProps)(LoggedOutComponent);



// WEBPACK FOOTER //
// ./src/components/header/membernav/LoggedOutComponent.js